import React, { useState } from "react";
import loginLogo from "../../Assets/Images/brand-logo.png";
// import "../../Assets/Images/loginPage-banner.jpg";
import "../../Pages/LoginPage/LoginPage.scss";
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { API_BASE_URL } from "../../utils/index";
import Swal from "sweetalert2";
import { ToastContainer, toast } from 'react-toastify';
import { MdOutlineAlternateEmail } from "react-icons/md";
import { FaEye, FaEyeSlash, FaGoogle, FaApple, FaFacebookSquare } from "react-icons/fa";
import { Modal, Button, Form } from 'react-bootstrap';
import { useAuthHeaders } from "../Token";
export default function Login() {
  const [email, setEmail] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [hide, setHide] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post(`${API_BASE_URL}/admin/login`, {
        email: email,
        password: verifyPassword,
      })
      .then((result) => {
        console.log("result Login @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@", result.data.data.accessToken);
        const accessToken= result.data.data.accessToken;
        const refreshToken = result.data.data.refreshToken;
        console.log(accessToken, "@@@@@@@@@@@@@@@@DDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD")

        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);
        Swal.fire({
          icon: "success",
          title: "Login Success",
          showConfirmButton: false,
          timer: 1500,
        });
        console.log("Before login ")
        navigate("/profilepage");
        console.log("After navigate profile",)

      })
      .catch((error) => {
        // console.log("error", error)
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      });
  };

  return (


    <>

      <div className="poistion-relative Login-box mt-5">

        <form onSubmit={handleSubmit} className="box-model">
          <div className='logo-img'>
          </div>
          <div className="text-center"><p className="mt-2">Welcome to </p>
            <h5 id="pop-Alert" >Chennai Auction Property</h5>
            <p>Please Login your account</p>
          </div>



          <div className="box-1" >
            <input
              type="EMail"
              id="EMail"
              value={email}
              className="box-input "
              placeholder=' EMail'

              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {/* <MdOutlineAlternateEmail className="text-indent" id="inputGroupPrepend3" /> */}
          </div>
          <div className="box-1">

            <input
              type={verifyPassword ? "text" : "password"}
              id="password"
              placeholder=" Password"
              value={verifyPassword}
              className="box-input "

              onChange={(e) => setVerifyPassword(e.target.value)}
              required
            />
            <button onClick={() => setHide(!hide)} id="btnicon">
              {hide ? (
                <FaEye className="passwordbtn" />
              ) : (
                <FaEyeSlash className="passwordbtn" />
              )}

            </button>

          </div>
          <div className="check-box mt-3">
            <ul className="d-flex ">
              <li><input type="checkbox" className="mx-1" />Remember me </li>
              <li className=""><Button variant="link" style={{ marginLeft: "90px" }}>Forgot Password ?</Button></li>
            </ul>
          </div>
          <div className="text-center">

            <button className="btn btn-dark pt-1 mt-1 w-100" id="btn" disabled={false} >Singnup</button>
          </div>
          <p className="text-center"> Or Continue With</p>
          <ul className='d-flex me-4' style={{ justifyContent: 'center' }}>
            <li className='fs-2 p-1'><FaGoogle /></li>
            <li className='fs-2 p-1'><FaApple /></li>
            <li className='fs-2 p-1'><FaFacebookSquare /></li>
          </ul>
          <div className="text-center mt-2"> New member here?
            <Link to="/Login " className="ms-2">Register Now </Link>
          </div>
        </form>


      </div>

      <ToastContainer position="bottom-center"
        reverseOrder={false} />
    </>
  );
}
// import React, { useState } from "react";
// import loginLogo from "../../Assets/Images/login-logo.png";
// import "../../Pages/LoginPage/LoginPage.scss";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { ToastContainer } from "react-toastify";
// import { FaEye, FaEyeSlash, FaGoogle, FaApple, FaFacebookSquare } from "react-icons/fa";
// import { Button } from "react-bootstrap";
// import { API_BASE_URL } from "../../utils/index";
// import { useAuthHeaders } from "../Token";

// export default function Login() {
//   const [email, setEmail] = useState("");
//   const [verifyPassword, setVerifyPassword] = useState("");
//   const [hide, setHide] = useState(false);
//   const headers = useAuthHeaders();
//   const navigate = useNavigate();

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     axios
//       .post(`${API_BASE_URL}/admin/login`, { email, password: verifyPassword }, { headers })
//       .then((result) => {
//         const adminId = result.data.accessToken;
//         localStorage.setItem("accessToken", adminId);  // Ensure the key matches what ProfilePage checks
//         Swal.fire({
//           icon: "success",
//           title: "Login Success",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//         navigate("/profilepage");
//       })
//       .catch((error) => {
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response.data.message,
//         });
//       });
//   };

//   return (
//     <>
//       <div className="position-relative Login-box mt-5">
//         <form onSubmit={handleSubmit} className="box-model">
//           <div className="logo-img">
//             {/* <img src={loginLogo} alt="Login Logo" /> */}
//           </div>
//           <div className="text-center">
//             <p className="mt-2">Welcome to</p>
//             <h5 id="pop-Alert">Chennai Auction Property</h5>
//             <p>Please Login to your account</p>
//           </div>
//           <div className="box-1">
//             <input
//               type="email"
//               id="email"
//               value={email}
//               className="box-input"
//               placeholder="Email"
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//           </div>
//           <div className="box-1">
//             <input
//               type={hide ? "text" : "password"}
//               id="password"
//               placeholder="Password"
//               value={verifyPassword}
//               className="box-input"
//               onChange={(e) => setVerifyPassword(e.target.value)}
//               required
//             />
//             <button type="button" onClick={() => setHide(!hide)} id="btnicon">
//               {hide ? <FaEye className="passwordbtn" /> : <FaEyeSlash className="passwordbtn" />}
//             </button>
//           </div>
//           <div className="check-box mt-3">
//             <ul className="d-flex">
//               <li><input type="checkbox" className="mx-1" />Remember me</li>
//               <li className="ms-auto"><Button variant="link">Forgot Password?</Button></li>
//             </ul>
//           </div>
//           <div className="text-center">
//             <button className="btn btn-dark pt-1 mt-1 w-100" id="btn" type="submit">Login</button>
//           </div>
//           <p className="text-center">Or Continue With</p>
//           <ul className="d-flex" style={{ justifyContent: 'center' }}>
//             <li className="fs-2 p-1"><FaGoogle /></li>
//             <li className="fs-2 p-1"><FaApple /></li>
//             <li className="fs-2 p-1"><FaFacebookSquare /></li>
//           </ul>
//           <div className="text-center mt-2">New member here?
//             <Link to="/register" className="ms-2">Register Now</Link>
//           </div>
//         </form>
//       </div>
//       <ToastContainer position="bottom-center" reverseOrder={false} />
//     </>
//   );
// }

